import { Deal } from '../gql/dealGql';
import {
  Country,
  Deal as GeneratedDeal,
  Maybe,
  PaperworkType,
  TtNewBankEnum,
} from '../gql/generated/graphql';

import { countryRulesFor } from '../constants/countries';

import { canBankUseR1 } from './financialInfos';

const PaperworkLabelMap: Record<PaperworkType, string> = {
  [PaperworkType.LeaseEnd]: 'Lease End',
  [PaperworkType.RouteOne]: 'Route One',
  [PaperworkType.Paper]: 'Paper',
  [PaperworkType.Adobe]: 'Adobe',
};

export const getPaperworkLabel = (
  deal: Pick<GeneratedDeal, 'paperwork_type'> | Pick<Deal, 'paperwork_type'>,
) => {
  if (!deal.paperwork_type) {
    return '-';
  }

  return PaperworkLabelMap[deal.paperwork_type as PaperworkType] ?? '-';
};

const R1_CONTRACT_PAPERWORK_TYPES: string[] = [PaperworkType.LeaseEnd, PaperworkType.RouteOne];
export const doesDealUseR1Contract = (
  deal: Pick<GeneratedDeal, 'paperwork_type'> | Pick<Deal, 'paperwork_type'>,
) => deal.paperwork_type != null && R1_CONTRACT_PAPERWORK_TYPES.includes(deal.paperwork_type);

export type SigningPaperworkType = Exclude<PaperworkType, PaperworkType.Paper>;

const SIGNING_PAPERWORK_TYPES: SigningPaperworkType[] = [
  PaperworkType.LeaseEnd,
  PaperworkType.RouteOne,
  PaperworkType.Adobe,
];

export const getSigningPaperworkTypes = ({
  bankSlug,
  country,
}: {
  bankSlug: Maybe<TtNewBankEnum> | undefined;
  country: Maybe<Country> | undefined;
}): SigningPaperworkType[] =>
  SIGNING_PAPERWORK_TYPES.filter(
    (paperworkType) =>
      countryRulesFor(country).paperworkTypes.includes(paperworkType) &&
      (canBankUseR1(bankSlug) || !R1_CONTRACT_PAPERWORK_TYPES.includes(paperworkType)),
  );
